var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 150,
    viewBox: "0 0 128 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10h32c5.52 0 10 4.48 10 10v50c0 5.52-4.48 10-10 10H18c-5.52 0-10-4.48-10-10V20c0-5.52 4.48-10 10-10v0",
    stroke: "#005250",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34h32c5.52 0 10 4.48 10 10v50c0 5.52-4.48 10-10 10H40c-5.52 0-10-4.48-10-10V44c0-5.52 4.48-10 10-10",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34h32c5.52 0 10 4.48 10 10v50c0 5.52-4.48 10-10 10H40c-5.52 0-10-4.48-10-10V44c0-5.52 4.48-10 10-10v0",
    stroke: "#005250",
    strokeWidth: 2.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58h32c5.519 0 10 4.48 10 10v50c0 5.523-4.477 10-10 10H64c-5.52 0-10-4.481-10-10V68c0-5.52 4.48-10 10-10",
    fill: "#357C74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74 86l14 8-14 8V86",
    fill: "#fff",
    fillOpacity: 0.92
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 96c0 14 10 24 24 24",
    stroke: "#BDF436",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 92c0 2.484 2.016 4.5 4.5 4.5s4.5-2.016 4.5-4.5-2.016-4.5-4.5-4.5a4.502 4.502 0 00-4.5 4.5",
    fill: "#BDF436"
  })));
}
export default SvgCourseHero;